import Vue from 'vue';
import moment from 'moment'

Vue.filter('formatDate', function (value,arg1) {
  if (!value) return '';
  value = value.toString();
  if (arg1) return moment(String(value)).format(arg1)
  else return moment(String(value)).format('DD/MM/YYYY HH:mm')
})
